import { Appearance } from 'react-native';

import configs from '@webtrader/core/configs';
import { EProjectPlatform } from '@webtrader/core/configs/types';
import { EThemeScheme } from '@webtrader/core/themes';

export const checkIsNative = () => {
  return configs.platform === EProjectPlatform.NATIVE;
};

export const isDarkTheme = (scheme: EThemeScheme) => {
  if (scheme === EThemeScheme.SYSTEM) {
    return isSystemDarkTheme();
  }

  return scheme === EThemeScheme.DARK;
};

export const isSystemDarkTheme = () => {
  if (checkIsNative()) {
    return Appearance.getColorScheme() === 'dark';
  }

  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};
